import axios from 'axios'
import store from '~/store'
import router from '~/router'
import Swal from 'sweetalert2'

// Request interceptor
axios.interceptors.request.use(request => {
  const token = store.getters['auth/token'];
  if (token) {
    request.headers.common['Authorization'] = `Bearer ${token}`
    request.headers.common['X-APP-BUILD'] = process.env.MIX_APP_BUILD
  }

  // request.headers['X-Socket-Id'] = Echo.socketId()

  return request
});

// Response interceptor
axios.interceptors.response.use(response => response, error => {
    if (error.response !== undefined) {
        const { status } = error.response;

        if (status >= 500) {
            if ([
                window.location.protocol + "//" + window.location.host + "/api/server/phpfpm_restart",
                window.location.protocol + "//" + window.location.host + "/api/server/nginx_restart",
                window.location.protocol + "//" + window.location.host + "/api/server/asterisk_restart",
            ].includes(error.request.responseURL) === false) {
                Swal.fire({
                    type: 'error',
                    title: 'Упс...',
                    text: 'Что-то пошло не так! Пожалуйста, попробуйте еще раз.',
                    reverseButtons: true,
                    confirmButtonText: 'Ок',
                    cancelButtonText: 'Отмена'
                })
            }
        }

        if (status === 426) {
            if ([
                window.location.protocol + "//" + window.location.host + "/api/user",
                window.location.protocol + "//" + window.location.host + "/api/user?hold_sip",
            ].includes(error.request.responseURL) === true) {
                Swal.fire({
                    type: 'warning',
                    title: 'У вас не актуальная версия ЦРМ',
                    text: 'Сейчас вы будете принудительно перезагружены, если этого не произошло, перезагрузите страницу вручную сочетанием клавиш CTLR+R',
                    reverseButtons: true,
                    confirmButtonText: 'Ок',
                    cancelButtonText: 'Отмена'
                });
                setTimeout( () => {
                    window.location.reload();
                }, 5000);
            }
        }

        if (status === 403 && store.getters['auth/check']) {
            Swal.fire({type: 'warning', title: 'Доступ запрещен!',});
            router.push({ name: 'dashboard' });
        }

        if (status === 401 && store.getters['auth/check']) {
            window.location.href = "/login";

            // Swal.fire({
            //     type: 'warning',
            //     title: 'Сессия Истекла!',
            //     text: 'Пожалуйста, войдите в систему еще раз, чтобы продолжить.',
            //     reverseButtons: true,
            //     confirmButtonText: 'Ок',
            //     cancelButtonText: 'Отмена'
            // }).then(() => {
            //     // store.commit('auth/LOGOUT');
            //
            //     // router.push({ name: 'login' })
            //     window.location.href = "/login";
            // })
        }
    }

  return Promise.reject(error)
});
